import React from 'react'
import PropTypes from 'prop-types'
import { Box, styled, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CaratRightLightIcon from 'src/static/icons/caratRightLight'
/**
 * Follow Up Prompts Container
 * theme path: FollowUpPrompts.styleOverrides.container
 */
const PromptsContainer = styled(Box, {
  name: 'FollowUpPrompts',
  label: 'followUpPromptsContainer',
  overridesResolver: (props, styles) => [styles.container]
})(({ theme }) => ({
  marginTop: '9px',
  padding: '15px 16.556px 5px 16.556px',
  borderRadius: '30px',
  backgroundColor: '#CCE8ED73',
  '& h1': {
    fontSize: '16px',
    fontFamily: 'Inter',
    textAlign: 'center',
    fontWeight: 700,
    color: theme?.palette?.followUpPrompts?.title
  },
  '> svg': { height: '25px', width: '127px', marginBottom: '3px' },
  '@media all and (max-width: 560px)': { margin: '0px 0px 30px' }
}))

/**
 * Follow Up Single Prompt Container
 * theme path: FollowUpPrompts.styleOverrides.promptContainer
 */
const SinglePromptContainer = styled(Box, {
  name: 'FollowUpPrompts',
  label: 'followUpPromptsPromptContainer',
  overridesResolver: (props, styles) => [styles.promptContainer]
})(({ theme }) => ({
  '> div': {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  '& p': {
    fontSize: '14px',
    fontFamily: 'Inter',
    fontWeight: 400,
    color: theme?.palette?.followUpPrompts?.text,
    marginBottom: '10px'
  }
}))

const FollowUpPrompts = ({
  title,
  isFetching,
  prompts = [],
  onPromptClick,
  containerSx
}) => {
  const { t } = useTranslation()
  const followUpPromptsTitle = title || t('relatedPrompt')
  if (!(!isFetching && prompts && prompts.length > 0)) return <></>

  return (
    <PromptsContainer sx={containerSx} data-testid="follow-up-prompts">
      <Typography variant="h1">{followUpPromptsTitle}</Typography>
      <Box sx={{ padding: '8px' }}>
        {prompts.map((prompt, idx) => (
          <SinglePromptContainer key={idx}>
            <Box onClick={() => onPromptClick({ prompt, pos: idx + 1 })}>
              <Typography>{prompt}</Typography>
              <CaratRightLightIcon
                sx={{
                  height: '12px',
                  fill: '#EC8655'
                }}
              />
            </Box>
          </SinglePromptContainer>
        ))}
      </Box>
    </PromptsContainer>
  )
}

FollowUpPrompts.propTypes = {
  /**
   * Follow Up prompts title
   */
  title: PropTypes.string,
  /**
   * Follow Up prompts fetching
   */
  isFetching: PropTypes.bool,
  /**
   * Follow Up prompts to display
   */
  prompts: PropTypes.array,
  /**
   * On Follow Up prompt click
   */
  onPromptClick: PropTypes.func,
  /**
   * Custom styles for the container
   */
  containerSx: PropTypes.object
}

export default FollowUpPrompts
